















































import Vue from 'vue';
import { TipoImportacion } from '../config/enums';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

@Component
export default class ImportFile extends Vue {
  @Prop({
    default: false,
  })
  show!: boolean;
  @Prop({
    default: 'Importar',
  })
  titulo!: string;
  @Prop({
    default: 0,
  })
  tipo!: TipoImportacion;

  value: File = null;
  dialog: boolean = false;
  clearInputFile: boolean = true;
  showProgressBar: boolean = false;

  get canStart() {
    if (this.showProgressBar == false || this.value != null) return true;
    else return false;
  }

  @Watch('show')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.dialog = value;
  }

  handleFileChange(e: any) {
    if (e.target.files.length > 0) {
      this.value = e.target.files[0];
      this.showProgressBar = true;

      switch (this.tipo) {
        case TipoImportacion.cargaAcciones:
          break;
        case TipoImportacion.cargaRoles:
          break;
        case TipoImportacion.cargaUsuarios:
          break;
        case TipoImportacion.cargaPerfiles:
          break;
      }

      //1.- validar formato archivo
      //2.- validar data archivo
      //3.- retornar información

      if (!this.showProgressBar) {
        this.$emit('importEventCallback', e.target.files[0]);
      }
    } else this.value = null;
  }

  closeModal(file: any) {
    this.showProgressBar = false;
    this.value = null;

    this.clearInputFile = false;
    this.$nextTick(function() {
      this.clearInputFile = true;
    });

    this.$emit('importEventCallback', file);
  }
}
